import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

// 为 H5 应用启用 Vue Router
Vue.use(VueRouter)

/**
 * H5 应用的子路由配置
 * 这些是相对于 /h5 的子路由
 */
export const h5Routes: Array<RouteConfig> = [
  {
    path: '',
    redirect: 'home'
  },
  {
    path: 'home',
    name: 'H5Home',
    component: () => import('@/views/h5/home.vue'),
    meta: { title: 'H5 首页' }
  },
  {
    path: 'device',
    name: '设备管理',
    component: () => import('@/views/h5/device/index.vue'),
    meta: { title: '设备管理' }
  },
  {
    path: 'device/edit',
    name: 'H5DeviceEdit',
    component: () => import('@/views/h5/device/edit.vue'),
    meta: { title: '设备编辑' }
  },
]
